/** Prefix of the dnd item id of an empty Photo Guide slot; the rest is its Photo Type. */
export const PHOTO_GUIDE_SLOT_DND_ID_PREFIX = 'photo-guide-slot:';
